/* eslint-disable no-unused-vars */
/**
 * @file Controle da execução em jogo.
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from "react";

//Logos
/* eslint-disable no-unused-vars */

//Componentes de roteamento
import { BrowserRouter as Router, Switch, Route, Link, Navigate, useNavigate } from "react-router-dom";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

class Vitoria extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.updateProgresso();
  }

  proximaFase() {
    console.log("Level atual", this.props.ControleJogo.ControleModo.getFase());
    this.props.ControleJogo.manageLevel(this.props.ControleJogo.ControleModo.getFase() + 1);
    this.props.ControleJogo.init();
    this.props.navigate('/jogo')
  }

  updateProgresso() {
    console.log("modulo auth", this.props.Serve.auth.usuario);
    this.props.Serve.auth.usuario.setProgresso(this.props.ControleJogo.ControleModo.getFase(), this.props.ControleJogo.state.pontos, this.props.ControleJogo.state.tempo)
  }

  progresso(estrela) {
    let pontos = this.props.Serve.auth.usuario.estrelas[estrela]
    if (pontos >= this.props.ControleJogo.state.pontos)
      return "star_outline"
    else
      return "star"
  }

  fracaoprogresso() {
    let pontos = this.props.ControleJogo.state.pontos
    let maximo = this.props.Serve.auth.usuario.estrelas[3]
    if (pontos >= maximo)
      return (maximo) * 100

    else
      return (pontos / maximo) * 100
  }

  faseConcluir() {
    if (this.props.ControleJogo.ControleModo.getFase() == 10) {
      return (<p className="p-2 text-color1 bg-white1">
        Você concluiu todos as fases:
      </p>)
    } else {
      return (<div className="my-2 my-md-0">
        <button
          type="button"
          className="button-custom inicial vitoriabutton bg-color4 arround-6"
          onClick={() => this.proximaFase()}
        >
          <span className="material-icons-outlined md-36 align-middle pe-3">
            arrow_right
          </span>
          Próxima Fase
        </button>
      </div>)
    }
  }

  render() {
    // ROTEAMENTO - colocar controle de estados da aplicação
    return (
      <div className="d-flex w-100 flex-row  min-vh-100  align-items-center p-0">
        <div className="d-flex flex-column container align-items-center w-100 view2 pt-2 arround-12  ">
          <div className="d-flex w-100  h-100 bg-color1  arround-12 p-5">
            <div className=" text-center flex-fill row w-100  h-100 bgVitoria  d-flex flex-row bg-white1 align-items-center w-100 arround-12 ">
              <div className="col-md">
                <div className="w-100 d-flex py-2 align-items-center">
                  <p className=" vitoria p-2 mx-5 flex-fill align-self-center bg-color1 w-fit arround-12">
                    PARABÉNS!
                  </p>
                </div>
                <div className="flex-fill d-flex justify-content-evenly flex-wrap flex-row p-md-5">
                  <div className="d-flex mt-2 flex-row visor bg-color1 ">
                    <div className="tag text-white1 flex-grow-1 align-text-bottom">
                      Cronômetro
                    </div>
                    <div
                      id="time_value"
                      className="value bg-white1 text-color1"
                    >
                      {(
                        "00" + this.props.ControleJogo.state.tempo.minutes
                      ).slice(-2)}
                      :
                      {(
                        "00" + this.props.ControleJogo.state.tempo.seconds
                      ).slice(-2)}
                    </div>{" "}
                  </div>
                  <div className="d-flex mt-2 flex-row visor bg-color1 align-items-center">
                    <div className="star-contain mt-3">
                      <div className="material-icons-outlined  align-middle">
                        {this.progresso(1)}
                      </div>
                      <div className="material-icons-outlined  align-middle">
                        {this.progresso(2)}
                      </div>
                      <div className="material-icons-outlined  align-middle">
                        {this.progresso(3)}
                      </div>
                    </div>
                    <div className="progress star-progress1 w-100">

                      <div className="progress-bar bg-danger progress-bar-striped progress-bar-animated star-progress" role="progressbar" aria-valuenow={this.fracaoprogresso()} aria-valuemin="0" aria-valuemax="100" style={{ width: this.fracaoprogresso() }}></div>

                    </div>
                  </div>
                  <div className="d-flex mt-2 flex-row visor bg-color1 ">
                    <div className="tag text-white1 flex-grow-1 align-text-bottom">
                      Pontuação
                    </div>
                    <div className="value bg-white1 text-color1">
                      {this.props.ControleJogo.state.pontos < 0
                        ? "-" +
                        (
                          "0000" +
                          this.props.ControleJogo.state.pontos * -1
                        ).slice(-4)
                        : ("0000" + this.props.ControleJogo.state.pontos).slice(
                          -4
                        )}
                    </div>
                  </div>
                </div>
                <p className="text-color1 bg-white1">
                  {" "}
                  Você concluiu o nível{" "}
                  {this.props.ControleJogo.ControleModo.getFase()}!
                </p>
              </div>

              <div className="col-md">
              <p className="text-white1 bg-color3">
                  Aprenda ainda mais enquanto se diverte! <br /> Desafie-se e
                  jogue novamente
                </p>
                <div className="d-flex flex-row col-md-flex justify-content-around">
                  {this.faseConcluir()}
                  <div className="my-2 my-md-0">
                    <Link to="/fases">
                      <button
                        type="button"
                        className="button-custom inicial vitoriabutton bg-color4 arround-6"
                      >
                        <span className="material-icons-outlined md-36 align-middle pe-3">
                          dashboard
                        </span>
                        Escolher Nível
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <Vitoria {...props} navigate={navigate} />
}

export default WithNavigate